import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

const RESIDUE_SELECTION_INFO_TEXT =
  'Enter comma-separated residue numbers or inclusive ranges (for example, 5..7,13). Omit a range endpoint to select from the start or through the end of the target sequence (..7 or 5..).';

export const RUN_BENCHLING_BOLTZGEN_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<
  PipelineStepType.RUN_BENCHLING_BOLTZGEN,
  0
> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'targetId',
    'predictionBatchFolderId',
    'predictionBatchName',
    'boltzGenConfig',
  ],
  targetId: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['targetId'],
    targetId: {
      displayName: 'Target amino-acid sequence',
      infoText: 'The Benchling amino-acid sequence that generated designs should bind.',
      configShapePath: ['targetId'],
    },
  },
  predictionBatchFolderId: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['predictionBatchFolderId'],
    predictionBatchFolderId: {
      displayName: 'Prediction batch folder',
      configShapePath: ['predictionBatchFolderId'],
    },
  },
  predictionBatchName: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['predictionBatchName'],
    predictionBatchName: {
      displayName: 'Prediction batch name',
      infoText: 'Leave blank to auto-generate a name.',
      configShapePath: ['predictionBatchName'],
    },
  },
  boltzGenConfig: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['boltzGenConfig'],
    boltzGenConfig: {
      displayName: 'BoltzGen configuration',
      configShapePath: ['boltzGenConfig'],
      fieldSettings: {
        tagKeyDisplayName: 'Protocol',
        tagKeyDisplayNames: {
          'antibody-anything': 'Antibody anything',
          'protein-anything': 'Protein anything',
        },
        choiceFieldOrder: [
          'numDesigns',
          'minLength',
          'maxLength',
          'scaffolds',
          'bindingResidues',
          'notBindingResidues',
        ],
        choiceUISchema: {
          numDesigns: {
            displayName: 'Number of designs',
            infoText: 'Generate between 1 and 100 designs.',
            configShapePath: ['numDesigns'],
          },
          minLength: {
            displayName: 'Minimum design length',
            configShapePath: ['minLength'],
          },
          maxLength: {
            displayName: 'Maximum design length',
            configShapePath: ['maxLength'],
          },
          scaffolds: {
            displayName: 'Antibody scaffolds',
            infoText: 'Select one or more registered BoltzGen antibody scaffolds.',
            configShapePath: ['scaffolds'],
          },
          bindingResidues: {
            displayName: 'Binding residues',
            infoText: RESIDUE_SELECTION_INFO_TEXT,
            configShapePath: ['bindingResidues'],
          },
          notBindingResidues: {
            displayName: 'Non-binding residues',
            infoText: RESIDUE_SELECTION_INFO_TEXT,
            configShapePath: ['notBindingResidues'],
          },
        },
      },
    },
  },
};
